<template>
    <div class="ck-validator" :style="{ marginLeft: marginLeft }">
        <span v-if="validationState === 'invalid'">
            <slot>{{ message }}</slot>
        </span>
    </div>
</template>

<script>
import Vue from 'vue';
import deepEqual from 'deep-equal';

// declarative validation
export default Vue.component('ck-validator', {
    props: {
        //TODO support array validators
        validators: {
            type: Object,
            default: () => { }
        },
        message: {
            type: String,
            default: ''
        },
        isValid: {
            type: Boolean,
            default: undefined
        },
        marginLeft: {
            type: String,
            default: '0px'
        }
    },

    computed: {
        computedValidators() {
            if (!this.validators) return [];
            return Array.isArray(this.validators) ? this.validators : [this.validators];
        },
        ckForm() {
            return this.getCkForm(this);
        },
        ckFormItem() {
            return this.getCkFormItem(this);
        }
    },

    mounted: function () {
        this.computeValidators(this.validators);
        
        this.ckFormItem.register(this);
        this.ckForm.register(this);

        this.initialize = false;
    },

    beforeDestroy: function () {
        this.ckFormItem.unregister(this);
        this.ckForm.unregister(this);
    },

    data() {
        return {
            validationState: 'unevaluated',
        }
    },

    methods: {
        getCkForm(x) {
            if (!x.$parent) return undefined;
            if (x.$parent.$options._componentTag === 'ck-form') return x.$parent;

            return this.getCkForm(x.$parent);
        },
        getCkFormItem(x) {
            if (!x.$parent) return undefined;
            if (x.$parent.$options._componentTag === 'ck-form-item') return x.$parent;

            return this.getCkFormItem(x.$parent);
        },
        computeTriggerValue(trigger) {
            if (!trigger) return 'submit';
            if (trigger.toLowerCase() !== 'submit'
                && trigger.toLowerCase() !== 'focus' //not supported
                && trigger.toLowerCase() !== 'change') return 'submit';
            return trigger;
        },
        computeValidators(after, before) {
            if (typeof after === 'object' && after.validator) {
                this.$set(after, 'trigger', this.computeTriggerValue(after.trigger));
                this.$set(after, 'message', this.message);
            }
        },
        checkValidity() {
            return (this.isValid !== undefined && this.isValid) || (_.every([this.validators], (item) => !item.isDirty || item.isValid));
        },
        computeValidationState() {
            this.validationState = this.checkValidity() ? 'valid' : 'invalid';
        }
    },

    watch: {
        validators: {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    this.computeValidators(newValue, oldValue);

                    if (this.initialize) {
                        if (!this.isDirty) this.isDirty = !_.isEqual(this.oldValue.model, newValue.model);

                        if (this.isDirty) {
                            this.ckForm._specificValidate('change', this._uid);
                        }

                        this.computeValidationState();
                    }
                    else {
                        this.initialize = true;
                    }

                    this.oldValue = _.cloneDeep(newValue);
                }
            },
            deep: true
        }
    }
});
</script>

<style>
.ck-validator {
    font-size: 14px;
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/ck-form/ck-validator.vue